import { Button } from '@cian/ui-kit';
import * as React from 'react';

interface IRaiseServiceLevelButtonProps {
  isMobile: boolean;
  text: string;
  onClick(): void;
}

export const RaiseServiceLevelButton = ({ isMobile, text, onClick }: IRaiseServiceLevelButtonProps) => {
  return (
    <Button type="button" theme="fill_success_secondary" fullWidth={isMobile} onClick={onClick}>
      {text}
    </Button>
  );
};
